import { render, staticRenderFns } from "./privacyEdit.vue?vue&type=template&id=641271b8&scoped=true&"
import script from "./privacyEdit.vue?vue&type=script&lang=js&"
export * from "./privacyEdit.vue?vue&type=script&lang=js&"
import style0 from "./privacyEdit.vue?vue&type=style&index=0&id=641271b8&lang=scss&scoped=true&"
import style1 from "./privacyEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641271b8",
  null
  
)

export default component.exports